export const DATASET_TYPE_SEMESTER = "semester_summary"
export const DATASET_TYPE_HOURLY = "semester_hourly"
